import { LoginType } from 'types'
import { Configuration } from 'core/environment/types'

export enum AccountTypes {
  User,
  SpecialUser,
}

export type AuthUserParams = {
  customer: Nullable<string>
  userId: Identifier
  password: string
}

export type UserLoginParams = AuthUserParams & {
  loginType: LoginType
}

export type AuthentificationResponse = {
  sessionToken: string
  isOceanEnabled: boolean
  shouldUseLegacyClient: boolean
  configuration: Configuration
}

export type ForgotPasswordParams = {
  customer: Nullable<string>
  email: Email
  accountId?: string
}

export type SetupPasswordParams = {
  password: string
  repeatPassword: string
}

export type SetupPasswordEmailLinkParams = {
  customer: string
  requestId: string
}

export type ChangePasswordParams = {
  password: string
  repeatPassword: string
}

export type RegisterParams = {
  installationName: string
  customer: string
  serialNumber: string
}

export type ConnectedPerson = {
  id: Identifier
  firstName: string
  lastName: string
}

export type GetAccountResponse = {
  login: string
  email: Email
  isLocked: boolean
  name: string
  isDeclarationConfirmed: boolean
  passwordChangeRequired: boolean
  hasAvatar: boolean
  type: AccountTypes
  connectedPerson: ConnectedPerson
}

export type LoginQueryParams = {
  backUrl?: string
  returnUrl?: string
  company?: string
  ecn?: string
  ssol?: string
}
